import React from "react";
import { Link } from "@sscs/ui";

const FooterLinks = () => (
  <small>
    All rights reserved ReversingLabs © 2026 |{" "}
    <Link
      href="https://www.reversinglabs.com/privacy-policy"
      target="_blank"
      inline
    >
      Privacy Policy
    </Link>{" "}
  </small>
);

export default FooterLinks;
